import { render, staticRenderFns } from "./areaCode.vue?vue&type=template&id=6ae7ee09&scoped=true&"
import script from "./areaCode.vue?vue&type=script&lang=js&"
export * from "./areaCode.vue?vue&type=script&lang=js&"
import style0 from "./areaCode.vue?vue&type=style&index=0&id=6ae7ee09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7ee09",
  null
  
)

export default component.exports